import React from "react"
import { IContext } from "../../models/IContext"
import { isLive } from "../../models/Utils"
import { AppRoot, RootContext } from "../AppRoot"
import { LeaderBoardDisplay } from "../base/LeaderBoardDisplay"

export class Home extends React.Component{
    private interval: NodeJS.Timeout

    initInterval = (fn: IContext["resetCurrentLive"]) => this.interval = setInterval(() => AppRoot.loadBoards(({ currentLive }) => fn(currentLive)), 10000)

    componentWillUnmount = () => clearInterval(this.interval)

    render = () => <RootContext.Consumer>
        {
            ({ currentLive, lastLive,resetCurrentLive }) => {
                const isInLive = isLive(currentLive),
                board = isInLive ? currentLive : lastLive

                if(!board)
                    return <></>

                if(!this.interval && isInLive)
                    this.initInterval(resetCurrentLive)

                return <LeaderBoardDisplay leaderboard={board.leaderboard} />
            }
        }
    </RootContext.Consumer>
}